import '@splidejs/splide/css/core';
import Splide from '@splidejs/splide';

var initializeBlock = function( $block ) {

  if(!!$block[0]){
    $block = $block[0];
  }
    
  let testimonialsSlider = $block.querySelector('.testimonials-slider__testimonials__slider');
  
  var splide = new Splide( testimonialsSlider , {
    type: 'fade',
    speed: 1000,
    arrows: false,
    pagination: true,
    rewind: true,
    waitForTransition: false,
  });
  splide.mount();

  var previousButton = document.querySelector('.testimonials-slider__prev-next__prev');
  var nextButton = document.querySelector('.testimonials-slider__prev-next__next');

  // Go to the previous slide when the Previous button is activated
  previousButton.addEventListener('click', function(e) {
    splide.go('<');
  });
  
  // Go to the next slide when the Next button is activated
  nextButton.addEventListener('click', function(e) {
    splide.go('>');
  });

}

// Initialize each block on page load (front end).
document.addEventListener( 'DOMContentLoaded', function() {
  var sliders = document.querySelectorAll('.testimonials-slider');
  Array.prototype.forEach.call(sliders, function(el, i){
    initializeBlock(el);
  });
});

// Initialize dynamic block preview (editor).
if( window.acf ) {
  window.acf.addAction( 'render_block_preview/type=testimonials-slider', initializeBlock );
}